import type { ReactNode } from "react";
import type { DraggableProvided } from "react-beautiful-dnd";

/**
 * Same pattern as content-manager lesson rows: one node owns ref, draggable, and drag-handle props.
 */
export default function RbdFullRowDragSurface({
  provided,
  children,
  className,
}: {
  provided: DraggableProvided;
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      ref={provided.innerRef}
      {...provided.draggableProps}
      {...provided.dragHandleProps}
      style={{
        ...provided.draggableProps.style,
        userSelect: "none",
      }}
      className={className}
    >
      {children}
    </div>
  );
}
